import React from 'react'
import { Route, Switch, Link } from 'react-router-dom'
import { useSelector } from 'hooks'
import { UpgradeButton } from 'components/Button'
import { Icon } from 'components/Icon'
import Filters from 'components/Filters'
import SiteLogo from 'components/SiteLogo'
import { T } from 'components/Translations'
import NotificationsPanel from './NotificationsPanel'
import UserPanel from './UserPanel'
import Photofilter from './Photofilter'
import Title from './Title'
import { VirtualHottieTag } from 'components/VirtualHottieTag'
import { isMobile } from 'styles'
import StyledHeader, { HeaderBottom } from './StyledHeader'

const UserHeader = () => {
  const { screenName, online, HILP } = useSelector(s => s.userProfile)
  return (
    <>
      <h1 className="username section-title">
        {screenName}
        <span className={`online-indicator ${online ? 'online' : 'offline'}`} />
      </h1>
      {HILP && !isMobile() && <VirtualHottieTag />}
    </>
  )
}

const ChatHeader = () => {
  const { nickname, screenName } = useSelector(s => s.userProfile)
  return (
    <h1 className="section-title chat-title">
      <Link to="/mailbox">
        <Icon name="arrow-left" />
      </Link>
      <Link to={`/members/${nickname}`}>{screenName}</Link>
    </h1>
  )
}

const Header = () => {
  const { HILP } = useSelector(s => s.userProfile)
  return (
    <>
      <StyledHeader>
        <Switch>
          <Route path="/browse" component={Filters} />
          <Route path="/members/:nickname/chat" component={ChatHeader} />
          <Route path="/mailbox/chat" component={ChatHeader} />
          <Route path="/members" component={UserHeader} />
          <Route path="/" exact>
            <T as="h1" className="section-title" label="sections/newMembers" />
          </Route>
          <Route component={Title} />
        </Switch>

        <SiteLogo />

        <div className="header-right">
          <div className="header-panels-upgrade">
            <UpgradeButton className="button-cta" size="large" />
            <NotificationsPanel />
            <UserPanel />
          </div>
          <Photofilter />
        </div>
      </StyledHeader>

      <HeaderBottom>
        <div className="row filters-row">
          <Route path="/browse" component={Filters} />
        </div>
        <div className="row upgrade-filters-row">
          <UpgradeButton className="button-cta" size="large" />
          <div className="header-panels">
            <Photofilter />
            {HILP && isMobile() && <VirtualHottieTag />}
          </div>
        </div>
      </HeaderBottom>
    </>
  )
}

export default Header
